import HTForm from '../../_shared/form/htform';

export default class RatingForm extends HTForm {
    /**
     * Form field items and validation rules
     */
    setup() {
        return {
            fields: [
                {
                    name: 'Rating',
                    type: 'radio'
                },
                {
                    name: 'Comments',
                    rules: 'string|between:1,250'
                }
            ]
        };
    }

    /**
     * Event Hooks
     */
    hooks() {
        return {
            onSuccess(form) {
                this.store.rate(form.values());
            }
        };
    }
}
